module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs notes-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n      关联作废发票：" + _vm._s(_vm.listData.length) + " 张\n      "), (_vm.totalAmount) ? _c('span', [_vm._v(" 开票总额：" + _vm._s(_vm.totalAmount) + "元")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "item-list"
  }, [(!_vm.listData.length) ? _c('li', {
    staticClass: "item center"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listData), function(item) {
    return _c('li', {
      staticClass: "item hc-red"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.invoiceDate))]), _vm._v(" "), _c('div', {
      staticClass: "order"
    }, [_c('div', {
      staticClass: "id"
    }, [_c('i', {
      staticClass: "ico orange"
    }, [_vm._v("￥")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          _vm.openDetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.sheetNo))])]), _vm._v(" "), _c('div', {
      staticClass: "good"
    }, [_vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v("￥" + _vm._s(item.totalMoney))])]), _vm._v(" "), _c('div', {
      staticClass: "response"
    }, [_vm._v("申请人：" + _vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "status"
    }, [_vm._v("已作废")])])])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "thumb"
  }, [_c('i', {
    staticClass: "web-icon-dollar-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d2a8d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/red-contract/canceled-invoice.vue
// module id = 1208
// module chunks = 82